// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseCustomerFactory instead of class inheritance

import { createBaseCustomer, type IBaseCustomer } from "../BaseCustomerFactory";
import {
	createDownloadMethod,
	createDownloadWithFileNameMethod,
	createDownloadMultipleMethod,
} from "./helpers/filesNotaryMethodsHelpers";

export interface FilesNotaryDownloadResult {
	blob: Blob;
	fileName: string;
	contentType: string | null;
	contentDisposition: string | null;
}

interface FilesNotaryInstance {
	download(filesNotaryUid: string, documentsNotaryUid: string, withCertificate?: boolean): Promise<Blob>;
	downloadWithFileName(
		filesNotaryUid: string,
		documentsNotaryUid: string,
		withCertificate?: boolean,
		fallbackFileName?: string,
	): Promise<FilesNotaryDownloadResult>;
	downloadMultiple(fileUids: string[], includeAnchors?: boolean, folderNumber?: string, folderName?: string): Promise<Blob>;
}

// Module-level singleton instance
let instance: FilesNotaryInstance | null = null;
let baseCustomerInstance: IBaseCustomer | null = null;

function createFilesNotary(): FilesNotaryInstance {
	if (!baseCustomerInstance) {
		baseCustomerInstance = createBaseCustomer();
	}

	const baseCustomer = baseCustomerInstance;
	const baseUrl = baseCustomer.namespaceUrl.concat("/files-notary");

	return {
		download: createDownloadMethod(),
		downloadWithFileName: createDownloadWithFileNameMethod(baseCustomer, baseUrl),
		downloadMultiple: createDownloadMultipleMethod(baseCustomer, baseUrl),
	};
}

export function getFilesNotaryInstance(): FilesNotaryInstance {
	if (!instance) {
		instance = createFilesNotary();
	}
	return instance;
}
